/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarehouseCreditBucketDTOFromJSON, WarehouseCreditBucketDTOToJSON, } from './WarehouseCreditBucketDTO';
/**
 * Check if a given object implements the WarehouseCreditSummaryDTO interface.
 */
export function instanceOfWarehouseCreditSummaryDTO(value) {
    return true;
}
export function WarehouseCreditSummaryDTOFromJSON(json) {
    return WarehouseCreditSummaryDTOFromJSONTyped(json, false);
}
export function WarehouseCreditSummaryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'payableCount': json['payableCount'] == null ? undefined : json['payableCount'],
        'payableCostUsd': json['payableCostUsd'] == null ? undefined : json['payableCostUsd'],
        'unknownCostCount': json['unknownCostCount'] == null ? undefined : json['unknownCostCount'],
        'initialCostCount': json['initialCostCount'] == null ? undefined : json['initialCostCount'],
        'estimatedCostCount': json['estimatedCostCount'] == null ? undefined : json['estimatedCostCount'],
        'heldCount': json['heldCount'] == null ? undefined : json['heldCount'],
        'heldCostUsd': json['heldCostUsd'] == null ? undefined : json['heldCostUsd'],
        'buckets': json['buckets'] == null ? undefined : (json['buckets'].map(WarehouseCreditBucketDTOFromJSON)),
    };
}
export function WarehouseCreditSummaryDTOToJSON(json) {
    return WarehouseCreditSummaryDTOToJSONTyped(json, false);
}
export function WarehouseCreditSummaryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'payableCount': value['payableCount'],
        'payableCostUsd': value['payableCostUsd'],
        'unknownCostCount': value['unknownCostCount'],
        'initialCostCount': value['initialCostCount'],
        'estimatedCostCount': value['estimatedCostCount'],
        'heldCount': value['heldCount'],
        'heldCostUsd': value['heldCostUsd'],
        'buckets': value['buckets'] == null ? undefined : (value['buckets'].map(WarehouseCreditBucketDTOToJSON)),
    };
}
